import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Hero from "./components/Hero";
import CredibilityStrip from "./components/CredibilityStrip";
import Signature from "./components/Signature";
import WorkWithMe from "./components/WorkWithMe";
import SipSessions from "./components/SipSessions";
import Moments from "./components/Moments";
// import Byteme from "./components/Byteme"; // Removed for now
import Community from "./components/Community";
import Footer from "./components/Footer";
import FuturisticBackground from "./components/FuturisticBackground";
import AnalyticsTracker from "./components/AnalyticsTracker";

// Admin components
import AdminLogin from "./components/admin/AdminLogin";
import AuthCallback from "./components/admin/AuthCallback";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminDashboard from "./components/admin/AdminDashboard";

// Media Kit (unlisted)
import MediaKit from "./components/MediaKit";

// Emergent job application (unlisted)
import EmergentPage from "./components/EmergentPage";

// Dear Dia application (unlisted)
import DearDia from "./components/DearDia";
import DearDutchie from "./components/DearDutchie";

const Home = () => {
  return (
    <main className="min-h-screen relative">
      <FuturisticBackground />
      <AnalyticsTracker />
      <div className="relative z-10">
        <Hero />
        <CredibilityStrip />
        <Signature />
        <WorkWithMe />
        <SipSessions />
        <Moments />
        {/* <Byteme /> */}
        <Community />
        <Footer />
      </div>
    </main>
  );
};

// Router component to handle auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (handles OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/fashion-tech-media" element={<MediaKit />} />
      <Route path="/emergent" element={<EmergentPage />} />
      <Route path="/DearDia" element={<DearDia />} />
      <Route path="/deardia" element={<DearDia />} />
      <Route path="/DearDutchie" element={<DearDutchie />} />
      <Route path="/deardutchie" element={<DearDutchie />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      {/* Redirect /admin to dashboard */}
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
